import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
	interface Window {
		gtag?: (...args: unknown[]) => void;
	}
}

export const useAnalytics = (hospitalName?: string, ready = false) => {
	const location = useLocation();
	const hospitalNameRef = useRef(hospitalName);

	useEffect(() => {
		hospitalNameRef.current = hospitalName;
	}, [hospitalName]);

	useEffect(() => {
		if (!window.gtag || !ready) return;

		window.gtag("event", "page_view", {
			page_path: location.pathname + location.search,
			page_title: document.title,
			...(hospitalNameRef.current && { hospital: hospitalNameRef.current }),
		});
	}, [location, ready]);
};
